import React, { Component } from "react";
import Sidebar from '../../Components/Sidebar';
import { Translation } from './Translation';

export class TranslationComponent extends Component {
  render() {
    return (
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading" >
              <h1>Translations</h1>
            </div>
          </div>
          <Translation />
        </div>
      </div>
    );
  }
}
